import React, { createContext } from 'react';

type StartFlowParams = {
  skipCanopyStep?: boolean;
  reconnectToken?: string;
  isPlatformNative?: boolean;
  onAbortFlow?: () => void;
  onCompletedFlow?: () => void;
};

type CanopyFlowContextProps = {
  startFlow: (params?: StartFlowParams) => void;
  isPlatformNative?: boolean;
};

const CanopyFlowContext: React.Context<CanopyFlowContextProps> = createContext({
  startFlow: () => null,
});

export default CanopyFlowContext;
